import { io } from "socket.io-client";
import BaseUrl from "../constants/BaseUrl";

const socket = io(BaseUrl);

export default socket